export default {"src":"/_next/static/media/Nara_coco_detective.6423303c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};